<h5 class="text-muted fw-normal mb-4">Benvenuto su Homie</h5>
<div class="mt-3 text-center" *ngIf="showAcceptButton">
  <button class="btn btn-primary" (click)="accept()" class="d-none">
    Accetta l'invito
  </button>
</div>
